import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'p-expandable-text',
  templateUrl: './p-expandable-text.component.html',
  styleUrls: ['./p-expandable-text.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PExpandableTextComponent {
  @Input() text: string | null = null;
  @Input() maxLines = 3;

  expanded = false;

  toggle(): void {
    this.expanded = !this.expanded;
  }
}
